// src/modules/units/tyres/views/retread-batch/retreadbatchcancel.js
//
// Orchestrator for cancelling a batch. A DRAFT just becomes Cancelled (no tyres
// have moved); an OPEN batch's tyres return to stock. cancelRetreadBatch flags the
// move, so both the detail behind and the dashboard tiles refetch on the events.

import { cancelRetreadBatch } from '../retread-batch.api.js';
import { RECOVERY, RETREAD_BATCH_STATUS } from '../../shared/retread-batch-core.js';
import { confirmHTML } from './retreadbatchconfirm.view.js';

function el(html) {
  const t = document.createElement('template');
  t.innerHTML = html.trim();
  return t.content.firstElementChild;
}

/**
 * @param {HTMLElement} viewEl
 * @param {object} ctx
 * @param {object} ctx.batch  the batch (needs retreadBatchId; status/lineCount for the copy)
 * @param {() => void} [ctx.onClose] keep / back
 * @param {() => void} [ctx.onDone]  a successful cancel -> back to the (refetched) detail
 * @returns {() => void} teardown
 */
export function renderRetreadBatchCancel(viewEl, ctx = {}) {
  let disposed = false;
  const batch = ctx.batch || {};
  const batchId = batch.retreadBatchId;
  const isOpen = batch.status === RETREAD_BATCH_STATUS.OPEN;
  const n = Number(batch.lineCount);
  const countBit = Number.isFinite(n) && n > 0 ? `${n} ${n === 1 ? 'tyre' : 'tyres'}` : 'the tyres';

  const root = el(`<div class="tm-rb-cancel-root">${confirmHTML({
    title: 'Cancel this batch?',
    sub: isOpen
      ? 'The batch is out at the retreader.'
      : 'This draft will be cancelled.',
    warn: isOpen ? `${countBit} return to stock.` : '',
    confirmLabel: 'Cancel batch',
    cancelLabel: 'Keep batch',
    danger: true
  })}</div>`);
  viewEl.replaceChildren(root);

  const msgEl = root.querySelector('[data-confirm-msg]');
  const okBtn = root.querySelector('[data-confirm-ok]');
  const cancelBtn = root.querySelector('[data-confirm-cancel]');

  function setMsg(text, kind) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.hidden = !text;
    msgEl.className = `tm-form-msg${kind ? ` tm-form-msg-${kind}` : ''}`;
  }
  function setBusy(on) {
    if (okBtn) okBtn.disabled = on;
    if (cancelBtn) cancelBtn.disabled = on;
  }

  async function doCancel() {
    setBusy(true);
    setMsg('Cancelling…');
    const res = await cancelRetreadBatch(batchId, { reason: 'cancel' });
    if (disposed) return;
    setBusy(false);
    if (res.success) { if (typeof ctx.onDone === 'function') ctx.onDone(); return; }
    if (res.status === 403) setMsg('You need administrator access to cancel this batch.', 'error');
    else if (res.recovery === RECOVERY.WAIT || res.locked) setMsg('The batch is busy with another operation — try again shortly.', 'error');
    else setMsg(res.message || 'Could not cancel the batch.', 'error');
  }

  okBtn?.addEventListener('click', doCancel);
  cancelBtn?.addEventListener('click', () => { if (typeof ctx.onClose === 'function') ctx.onClose(); });

  return () => { disposed = true; };
}
